import React, { useEffect } from 'react'

import { useParams } from 'react-router-dom'

import useStyles from './message.style'

import { useDispatch, useSelector } from 'react-redux'
import { getMessages } from '@actions/message'

import firebase from 'firebase/app'

import moment from 'moment'

import Image from '@components/image/image.component'
import ParsedText from '@components/parsed-text/parsed-text.component'
import Splash from '@components/splash/splash.component'

const Message = (props) => {
  const classes = useStyles(props)

  const { id } = useParams()

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getMessages(id))
  }, [dispatch, id])

  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      firebase.analytics().logEvent('MessageView', { messageId: id })
    }
  }, [id])

  const messageData = useSelector((state) => state.message)

  const {
    images,
    isLoading,
    message,
    subject,
    create_date: createDate,
    display_name: displayName
  } = { ...messageData }

  if (isLoading) return <Splash />

  return (
    <div className={classes.container}>
      <div className={classes.messageHeader}>
        <div className={classes.accountName}>{displayName}</div>
        {createDate && (
          <div className={classes.messageDate}>{`Posted ${moment(moment.utc(createDate)).local().fromNow()}`}
          </div>
        )}
      </div>
      <div className={classes.messageBody}>
        {subject &&
          <div className={classes.messageSubject}>
            <ParsedText
              className={classes.text}
              text={subject}
            />
          </div>}
        {message && (
          <div className={classes.messageDescription}>
            <ParsedText
              className={classes.text}
              text={message}
            />
          </div>
        )}
        {images?.length > 0 &&
          images.map((src, index) => (
            <div key={`image-${index}`}>
              <Image
                modal
                src={src}
              />
            </div>))}
      </div>
    </div>
  )
}

export default Message
